// extracted by mini-css-extract-plugin
export var table = "_vi-0";